import { getCellSign } from '../../common';
import { numberWithCommas } from './numbers';
import { BillingCycleUnit } from '../../pricing';
import { Cell, CellTypes } from '../../pricingModelTable';
import { BillingCycleStruct } from '../../pricing/interfaces/billing-cycle';

const billingCycleLabels = {
  ONE_TIME: 'One Time',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
};

export const DATE_FORMAT = 'MMM D, YYYY';
export const YEARLY_DATE_FORMAT = 'MMM D';
export const DATE_FORMAT_SLASH = 'MM/DD/YYYY';
export const SHORT_YEAR_FORMAT = 'MMM DD, ‘YY';

export const getBillingCycleLabel = (cycle: BillingCycleStruct) => {
  switch (cycle.unit) {
    case BillingCycleUnit.ONE_TIME:
      return billingCycleLabels.ONE_TIME;
    case BillingCycleUnit.MONTHLY:
      return cycle.cycle === 1 ? billingCycleLabels.MONTHLY : `Every ${cycle.cycle} Months`;
    case BillingCycleUnit.YEARLY:
      return cycle.cycle === 1 ? billingCycleLabels.YEARLY : `Every ${cycle.cycle} Years`;
  }
};

export const getCellValue = (cell: Cell) => {
  const sign = getCellSign(cell?.cellType);

  let value: string | number;
  switch (cell?.cellType) {
    case CellTypes.NUMBER:
    case CellTypes.COUNT:
    case CellTypes.FORMULA:
    case CellTypes.PERCENTAGE:
      value = numberWithCommas(typeof cell?.cellValue === 'string' ? parseFloat(cell?.cellValue) : cell?.cellValue);
      break;

    default:
      value = cell?.cellValue || '';
      break;
  }
  return `${sign || ''}${value}`;
};
